import { Select } from '@mantine/core'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getAvailableEmitterTypes } from 'App/Map/_utils/getAvailableEmitterTypes'
import { getEmittersToSelect } from 'App/Map/_utils/getEmittersToSelect'
import { translate } from 'i18n/i18n'
import { useEffect } from 'react'
import { SharedSettings } from 'settings/SharedSettings'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { mapSelectedCardStore } from 'stores/mapSelectedCardStore/mapSelectedCardStore'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { sortByKey } from 'utils/sortByKey'

const ANY_EMITTER = 'ANY_EMITTER'

export const EmitterSelect = () => {
  const { properties } = fieldAssetStore.useSelector((s) => s)
  const selectedEmitters = mapControlsStore.useSelector((s) => s.selectedEmitters)
  const availableEmittersSet = getAvailableEmitterTypes(properties)
  const availableEmittersKey = availableEmittersSet.join()

  useEffect(() => {
    const currentSelectedEmitters = mapControlsStore.getState().selectedEmitters
    const emittersToSelect = getEmittersToSelect(currentSelectedEmitters, getAvailableEmitterTypes())

    if (emittersToSelect === currentSelectedEmitters) return

    mapControlsStore.setState((s) => ({
      ...s,
      selectedEmitters: emittersToSelect,
    }))
  }, [availableEmittersKey])

  const emitterOptions = availableEmittersSet
    .map((emitter) => ({
      label: mapApiEmitterTypeToLabel(emitter),
      value: emitter,
    }))
    .sort(sortByKey('label'))

  return (
    <Select
      data={
        availableEmittersSet.length > 1
          ? [{ label: translate.phrases.banyanApp('Any Emitter'), value: ANY_EMITTER }, ...emitterOptions]
          : emitterOptions
      }
      onChange={(emitter) => {
        mapControlsStore.setState((s) => ({
          ...s,
          selectedEmitters: emitter === ANY_EMITTER ? availableEmittersSet : [emitter as TEmitterType],
        }))

        mapSelectedCardStore.actions.hide()
      }}
      placeholder={translate.phrases.banyanApp('Select Emitter Type')}
      value={selectedEmitters.length > 1 ? ANY_EMITTER : selectedEmitters[0]}
      styles={SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER}
    />
  )
}
